import React from 'react';

interface Props {
    icon: JSX.Element;
    title: string;
    className?: string;
}

const EmptyList = ({icon, title, className}: Props) => {
    return (
        <div className={`empty-list ${className ?? ""}`}>
            <div className="circle-container">
                <div className={"center"}>
                    <div className="circle circle1"></div>
                </div>
                <div className={"center"}>
                    <div className="circle circle2"></div>
                </div>
                <div className={"center"}>
                    <div className="circle circle3"></div>
                </div>
                <div className={"center"}>
                    <div className="circle circle4"></div>
                </div>
                <div className={"center"}>
                    <div className={"center-svg"}>
                        {icon}
                    </div>
                </div>
            </div>
            <p className={"text-center fw-normal"}>
                {title}
            </p>
        </div>
    )
}

export default EmptyList;